// extracted by mini-css-extract-plugin
module.exports = {"imgEllipse":"index-module--imgEllipse--1WIZQ","swapperMap":"index-module--swapperMap--3Cy4J"};